module.exports = __webpack_public_path__ + "static/media/newsDefault.e777d2ce.svg";